import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useWorkstations } from '@/hooks/v1';
import { FormItem } from '../../../components/FormItem';
import { usePersonalisedReportContext } from '../../../../context';
import { WorkstationSelect } from '@/components/ui/Inputs/WorkstationSelect';

const { useFormInstance, useWatch } = Form;

export function Workstations(): JSX.Element {
	const form = useFormInstance();
	const { organization_id, company_id } = usePersonalisedReportContext();
	const sector_id = useWatch(['basic_information', 'sector_id'], form);

	const fieldName = ['basic_information', 'workstation_id'];

	const { isLoading, isFetching, data, isError } = useWorkstations({
		organization_id,
		company_id,
		sector_id
	});

	function handleOnChange(id: string): void {
		form.setFieldValue(fieldName, id);
	}

	function handleOnClear(): void {
		form.setFieldValue(['basic_information', 'activity_id'], undefined);
		form.setFieldValue(fieldName, undefined);
	}

	return (
		<Col xs={24}>
			<FormItem
				isRequired
				fontSize="1rem"
				title="Workstation"
				namePath={fieldName}
				errorMessage={I18n.get('Select a workstation')}
			>
				<WorkstationSelect
					size="large"
					workstations={data}
					sectorId={sector_id}
					loading={isFetching}
					handleSelectWorkstation={handleOnChange}
					handleClearWorkstations={handleOnClear}
					disabled={isLoading || isFetching || isError || !sector_id}
				/>
			</FormItem>
		</Col>
	);
}
